<template>
  <div class="row">
    <el-dialog
      left
      title="Add Carry Receipt"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      @close="handleCancel()"
      @open="open()"
      :visible.sync="isShow"
      style="margin: 0 auto"
      class="addCarryRecipientModal col-lg-12 col-sm-12 col-12 col-md-12"
    >
       <div
          v-for="(val, index) in details"
          :key="`phoneInput-${index}`"
          class="input wrapper flex items-center"
        >
      <div class="form-group">
      <div class="row" >
        <div class="col-4 mr-2" >
            <div style="margin-bottom: 10px" >Entity Name</div>
            <div class="input wrapper flex items-center">
              <input
                type="text"
                class="form-control"
                placeholder=""
                v-model="val.entity_name"
              />
          </div>
        </div>
      <div class="col-4 mr-2" >
        <div style="margin-bottom: 10px" >Email</div>
        <div class="input wrapper flex items-center">
          <input
            type="email"
            class="form-control"
            placeholder=""
            v-model="val.email"
          />
        </div>
      </div>
      <div class="col-3 mr-2" >
        <div style="margin-bottom: 10px" >Carry(%)</div>
        <div class="input wrapper flex items-center">
          <input
            type="number"
            class="form-control"
            placeholder=""
            v-model="val.carry"
          />
        </div>
      </div>
        <div class="d-flex align-items-center">
          <span v-show="details.length > 1"
            @click="removeField(index, details)">
            <i class="fa fa-trash pointer"></i>
          </span>
        </div>
    </div>
  </div>    
</div>
   <!-- <button @click="addField('', details)" class="btn mt-2 addButton"><i class="fa fa-plus" ></i>Add</button> -->
   <button @click="addField('', details)" type="button" class="todo-form-submit-button btn btn-primary">
      <i class="fa fa-plus" aria-hidden="true"></i>
      Add
    </button>
      <!-- <svg

            @click="addField(input, phoneNumbers)"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
            class="ml-2 cursor-pointer"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              fill="green"
              d="M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2h4zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
            />
          </svg> -->
      
      <div slot="footer" class="dialog-footer" style>
        <div style="border: 0.8px solid #ededed; opacity: 1"></div>
        <div class="col-xl edit-company-action-button-row" style="padding: 0px">
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancel"
          >
            Cancel
          </button>
          <button
            type="button"
            @click.prevent="writeToServer"
            class="todo-form-submit-button btn btn-primary"
          >
            Continue
            <!-- <i class="nc-icon nc-refresh-02 spinner" v-if="showSpinner"></i> -->
            <b-spinner
              v-if="showSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog } from "element-ui";
import { Select, Option } from "element-ui";

export default {
  name: "AddCarryReceipt",
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    value: {
      isShow: Boolean,
      data: Object,
    },
    carryRecipients: Array
  },
  data() {
    return {
      details: [{ entity_name: "", email: "", carry:""}],
      showSpinner: false,
    };
  },
  computed: {
    isShow: {
      get() {
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
        this.$emit("input", this.value);
      },
    },
    
  },
  methods: {
    handleCancel() {
      this.isShow = false;
      this.details= [{ entity_name: "", email: "", carry:""}]
    },
    addField(value, fieldType) {
      fieldType.push({ entity_name: "", email: "", carry:""});
    },
    removeField(index, fieldType) {
      fieldType.splice(index, 1);
    },
    writeToServer() {
      this.$emit("addCarryRecipients", this.details);
      this.handleCancel();
    },
    open(){
      if(this.carryRecipients && this.carryRecipients.length>0){
      this.details = this.carryRecipients
      }
    }
  },
};
</script>
<style lang="scss">
.buttonOutlined{
        background: none;
        color: #5445F399;
        border: 1px solid #5445F399;
  }
  .addCarryRecipientModal{
    .el-dialog__title{
      font-size: 16px;
      margin-top: 20px;
    }
  }

</style>






